
/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";

import "../../App.css";
import { Card, Col, Row, Form, Checkbox, Select, Radio, message, TimePicker } from "antd";
//import Jax from "../../Jax/jax.es6.module";
import TableIDs from "../../data/TableIDs";
import DateTimePicker from "../../components/DateTimePicker";
import ReportTypeButton from "../../components/ReportTypeButton";
import GenericSelector from "../../components/GenericSelector";
import PageToolbar from "../../components/PageToolbar";
import LangContext from "../../contextProvider/LangContext";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import * as XLSX from 'xlsx/xlsx.mjs';
import SelectorZList from "../../components/SelectorZList";
import moment from "moment";
import SelectorZBranchList from "../../components/SelectorZBranchList";

const FormItem = Form.Item;
const { Option, OptGroup } = Select;

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    baseUrl: string,
    data: Object,
    dataActions: Object,
    ActionQueue: any
};
type State = {};

class PaymentsAnalysis extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.filterSuppliers = '1,2,3,4,7,48,76';

        const firstMonthDay = moment().format("YYYY-MM-01")

        this.state = {
            loading: false,
            dateFrom: moment(firstMonthDay).add(-1, 'month').format("YYYY-MM-DD"),
            dateTo: moment(firstMonthDay).add(-1, 'day').format("YYYY-MM-DD"),
            branchList: '',
            compDetaild: 1,
            taxesView: 1,
            centralType: 1,
            payTypeList: '',
            payItemList: '',
            payItemsSumType: '1',
            orderSuppliers: '',
            zNumber: '',
            reportName: "reports/PaymentsAnalysis.pdf",
            reportType: "pdf",
            PosId: 999,
            addHours: '00:00:00',
        };


        if (props.data[TableIDs.genericSelectorBranches] === undefined) props.data[TableIDs.genericSelectorBranches] = { ...props.data.genericSelector };
        if (props.data[TableIDs.genericSelectorPaymentTypes] === undefined) props.data[TableIDs.genericSelectorPaymentTypes] = { ...props.data.genericSelector };
        if (props.data[TableIDs.genericSelectorExternalOrderSuppliers] === undefined) props.data[TableIDs.genericSelectorExternalOrderSuppliers] = { ...props.data.genericSelector };
        if (props.data.PAY_ITEMS_LIST === undefined) props.data.PAY_ITEMS_LIST = { ...props.data.genericSelector };


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.sendAPI("get_pay_items_list", "", ob => {
            if (!this.state.payItemList)
                this.setState({ payItemList: ob.data ? ob.data.split("\r").map(x => x ? x.split("\f")[1] : "").join(",") : "" })
        })

        if (!this.props.ui.favoriteParams) {

            this.sendAPI("get_all_gp_by_user", "", ob => {
                if (ob.data) {
                    ob.data.split("\r").forEach(x => {
                        let y = x.split("\f");
                        if (y[0] == 'GP_StartDayHour' && y[1] && y[1].length == 5) {
                            this.setState({ addHours: y[1] + ":00" })
                        }
                    })
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(14584);

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState({
                ...this.props.ui.favoriteParams,
                payItemList: decodeURIComponent(this.props.ui.favoriteParams.payItemList)
            })
        }
    }

    createDatePicker = (label, field) => {
        return (<FormItem label={this.getText(label)}>
            <DateTimePicker
                format="DD/MM/YYYY"
                value={this.state[field]}
                onChange={(e) => { this.setState({ [field]: e }) }}
                minDate={field == 'dateTo' ? this.state.dateFrom : this.state.dateTo ? moment(this.state.dateTo).add(-1, 'year').format("YYYY-MM-DD") : null}
                maxDate={field == 'dateFrom' ? this.state.dateTo : this.state.dateFrom ? moment(this.state.dateFrom).add(1, 'year').format("YYYY-MM-DD") : null}
            />
        </FormItem>)
    }


    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCallback, e => { console.error(e) });
    }

    generateXlsxReport = (params) => {
        this.setState({ loading: true }, () => {

            // let dataSend = "dateFrom\fdateTo\fbranchList\fcompDetaild\fpayItemList\fpayItemsSumType\forderSuppliers\fzNumber\faddHours\fcentralType\r" +
            //     (params.dateFrom ?? "") + "\f" +
            //     (params.dateTo ?? "") + "\f" +
            //     (params.branchList ?? "") + "\f" +
            //     (params.compDetaild ?? "") + "\f" +
            //     (params.payItemList ?? "") + "\f" +
            //     (params.payItemsSumType ?? "") + "\f" +
            //     (params.orderSuppliers ?? "") + "\f" +
            //     (params.zNumber ?? "") + "\f" +
            //     (params.addHours ?? "") + "\f" +
            //     (params.centralType ?? "");

            this.sendAPI("get_payments_analysis_excel_data", this.state, (ob) => {
                let abcList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
                let colList = [...abcList];
                abcList.forEach(x => { abcList.forEach(y => { colList.push(x + y) }) });
                let excelData = {}
                let lastRow = 1;
                let lastCol = "A";
                let lastColIndex = 0;

                let styles = [{ width: 8 }];

                let fullData = ob.data ? ob.data.split("\r").map(x => x.split("\f").slice(1)) : [];

                fullData.forEach((x, i) => {
                    let row = i + 1
                    lastRow = row;
                    x.forEach((y, ii) => {
                        let col = colList[ii];
                        if (lastColIndex < ii) {
                            lastColIndex = ii;
                            lastCol = col;
                            styles.push({ width: 15 })
                        }
                        if (ii == 1 || i == 0) excelData = { ...excelData, [col + row]: { t: "s", v: y } }
                        else excelData = { ...excelData, [col + row]: { t: "n", v: y, z: "#,##0" } }
                    })
                })

                excelData = {
                    ...excelData,
                    ['!cols']: styles,
                    ["!ref"]: "A1:" + lastCol + lastRow,
                }

                // console.log("excelData", excelData)

                const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

                const wb = { Sheets: { data: excelData }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = new Blob([excelBuffer], { type: fileType });
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = "PaymentsAnalysisExcel.xlsx";
                a.click();

                this.setState({ loading: false })
            })

        })
    }

    render() {

        let divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        let mobile = window.innerWidth > 600 ? false : true;

        let params = { ...this.state };
        if (params.centralType == 3) params = { ...params, reportName: "reports/PaymentsAnalysisOneBranch.pdf" }
        if ([4, 5, 7, 8].find(f => f == params.centralType)) params = { ...params, reportName: "reports/Report80PaymentsAnalysisOneBranch.pdf" }
        let xlsReportName = params.reportName.split('.')[0] + ([4, 5, 7, 8].find(f => f == params.centralType) ? ".xls" : "Excel.xls");

        return (<div style={divStyle} >
            <Card title={(<PageToolbar title={this.getText(14585)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: window.innerWidth < 1200 ? '95%' : 1100 }}
                bodyStyle={{ padding: 16 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}>
                <Row>
                    <Col span={mobile ? 24 : 18}>
                        <FormItem label={this.getText(19070)}>
                            <Select
                                style={{ width: 250 }}
                                value={this.state.centralType}
                                onChange={(e) => { this.setState({ centralType: e }) }}>
                                <Option value={1}>{this.getText(19072)}</Option>
                                <Option value={3}>{this.getText(20206)}</Option>
                                <Option value={4}>{this.getText(20206)} - 80</Option>
                                <Option value={2}>{this.getText(19073)}</Option>
                                <Option value={5}>{this.getText(21142)}</Option>
                                <Option value={6}>{this.getText(21143)}</Option>
                                <Option value={7}>{this.getText(21144)}</Option>
                                <Option value={8}>{this.getText(22071)}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label={this.getText([1, 2, 6].find(f => f == params.centralType) ? 14588 : 20207)}>
                            <GenericSelector
                                multi={[1, 2, 6].find(f => f == params.centralType)}
                                id={TableIDs.genericSelectorBranches}
                                api={"get_branch_list"}
                                value={[1, 2, 6].find(f => f == params.centralType) ? this.state.branchList ? this.state.branchList.split(',') : [] : this.state.branchList}
                                onChange={(e) => { this.setState({ branchList: [1, 2, 6].find(f => f == params.centralType) ? e ? e.join(',') : '' : e }) }}
                                data={this.props.data}
                                dataActions={this.props.dataActions}
                                user={this.props.user}
                            />
                        </FormItem>
                        {[8].find(f => f == params.centralType) ?
                            <Form.Item label={this.getText(22072)}>
                                <SelectorZBranchList
                                    {...this.props}
                                    filters={{ zNumber: params.zNumber }}
                                    onChange={obj => { this.setState({ zNumber: obj.zNumber, dateFrom: obj.StartDate, dateTo: obj.EndDate, branchList: obj.branchList }) }}
                                />
                            </Form.Item>
                            : <>
                                <Row>
                                    <Col span={mobile ? 24 : 8}>{this.createDatePicker(14586, 'dateFrom')}</Col>
                                    <Col span={mobile ? 24 : 8}>{this.createDatePicker(14587, 'dateTo')}</Col>
                                    <Col span={mobile ? 24 : 8}>{this.state.dateFrom || this.state.dateTo ?
                                        <Form.Item label={this.getText(21115)}>
                                            <DateTimePicker format="HH:mm" value={this.state.addHours} onChange={(e) => { this.setState({ addHours: e }) }} />
                                        </Form.Item>
                                        : ""}</Col>
                                </Row>

                                <Form.Item label={this.getText(20205)}>
                                    <SelectorZList
                                        {...this.props}
                                        filters={{ zNumber: params.zNumber, StartDate: params.dateFrom, EndDate: params.dateTo, PosList: "" }}
                                        onChange={obj => { this.setState({ zNumber: obj.zNumber, dateFrom: obj.StartDate, dateTo: obj.EndDate }) }}
                                    />
                                </Form.Item>
                            </>}
                        {[4, 8].find(f => f == params.centralType) ?
                            <FormItem>
                                <Checkbox
                                    checked={this.state.taxesView == 1}
                                    onChange={(e) => { this.setState({ taxesView: e.target.checked ? 1 : 0 }) }}
                                >{this.getText(22070)}</Checkbox>
                            </FormItem>
                            : ""}

                        {[1, 3, 4, 8].find(f => f == params.centralType) ?
                            <FormItem>
                                <Checkbox
                                    checked={this.state.compDetaild == 1}
                                    onChange={(e) => { this.setState({ compDetaild: e.target.checked ? 1 : 0 }) }}
                                >{this.getText(14589)}</Checkbox>
                            </FormItem>
                            :
                            <FormItem label={this.getText(19071)}>
                                <GenericSelector
                                    multi
                                    id={TableIDs.genericSelectorPaymentTypes}
                                    api={"get_payment_types_list"}
                                    value={this.state.payTypeList ? this.state.payTypeList.split(',') : []}
                                    onChange={(e) => { this.setState({ payTypeList: e ? e.join(',') : '' }) }}
                                    data={this.props.data}
                                    dataActions={this.props.dataActions}
                                    user={this.props.user}
                                />
                            </FormItem>
                        }
                        <FormItem label={this.getText(19915)}>
                            <GenericSelector
                                {...this.props}
                                multi
                                optionsGroup
                                id={'PAY_ITEMS_LIST'}
                                api={"get_pay_items_list"}
                                value={this.state.payItemList ? this.state.payItemList.split(',') : []}
                                onChange={(e) => { this.setState({ payItemList: e ? e.join(',') : '' }) }}
                            />
                        </FormItem>
                        {this.state.payItemList.length ?
                            <FormItem>
                                <Radio.Group
                                    value={this.state.payItemsSumType}
                                    onChange={(e) => { this.setState({ payItemsSumType: e.target.value }) }}
                                >
                                    <Radio value={"1"}>{this.getText(19916)}</Radio><br />
                                    <Radio value={"2"}>{this.getText(19917)}</Radio>
                                </Radio.Group>
                            </FormItem>
                            : ""}
                        <FormItem label={this.getText(20030)}>
                            <GenericSelector
                                {...this.props}
                                multi
                                id={TableIDs.genericSelectorExternalOrderSuppliers}
                                api={'external_orders_supplier_logo_list'}
                                filterList={this.filterSuppliers.split(',')}
                                value={this.state.orderSuppliers ? this.state.orderSuppliers.split(",") : []}
                                onChange={(e) => { this.setState({ orderSuppliers: e?.join(",") }) }}
                            />
                        </FormItem>

                    </Col>
                    <Col span={mobile ? 24 : 6}>

                        <ReportTypeButton
                            {...this.props}
                            branchesField={'branchList'}
                            params={params}
                            zToFavorites={{ field: 'zNumber', label: this.getText(20205) }}
                            datesToFavorites={[
                                { field: 'dateFrom', label: this.getText(14586) },
                                { field: 'dateTo', label: this.getText(14587) },
                            ]}
                            encodeURIFields={['payItemList']}
                            onChange={e => { this.setState({ reportType: e }) }}
                            favoriteSave
                            xlsReportName={xlsReportName}
                            generateXlsxReport={params.centralType == 1 ? this.generateXlsxReport : null}
                            validSubmit={() => {
                                let df = new Date(this.state.dateFrom).getTime();
                                let dt = new Date(this.state.dateTo).getTime();
                                if ([3, 4, 5, 7, 8].find(f => f == params.centralType) && !this.state.branchList) message.error(this.getText(20208))
                                else if ([8].find(f => f == params.centralType) && !this.state.zNumber) message.error(this.getText(22078))
                                else if (![8].find(f => f == params.centralType) && this.state.payItemList && (!dt || !df || (dt - df) > (31 * 24 * 60 * 60 * 1000))) message.error(this.getText(19918))
                                else return true
                            }}
                            loading={this.state.loading}
                        />
                    </Col>
                </Row>

            </Card>
        </div >
        );
    }
}
export default PaymentsAnalysis;